import { Component, OnInit, ViewChild, Renderer2 } from '@angular/core';
import { catchError, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Observable, Subscription, Subject, throwError } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';
import Swal from 'sweetalert2';

import { AddProductsComponent } from '@teem/product-module/modals/add-products/add-products.component';
import { ACTIONS as PRODUCT_ACTIONS } from '@teem/constants/product';

import { ProductService } from '@teem/services/product.service';
import { LoaderService } from '@teem/services/loader.service';
import { SharedDataService } from '@teem/services/shared-data.service';
import { ImportProductModalComponent } from '@teem/product-module/modals/import-product-modal/import-product-modal.component';

import { environment } from '@teem/environments/environment';
import { queryString } from '@teem/helpers/functions';
import { products as ProductsApi } from '@teem/constants/api';
import { messages as i18n } from '@teem/constants/messages';
import { ProductTableComponent } from './components/product-table/product-table.component';

declare var $;

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {

  @ViewChild('searchInput') searchInput: any;
  @ViewChild(ProductTableComponent) productTableComponent!: ProductTableComponent;
  locale: string = 'en';
  categories: any[] = [];
	allProductCount: number = 0;
	products: any[] = [];
	isSearch: boolean = false;
  loading: boolean = false;
  search: Subject<string> = new Subject<string>();
  searchText: string;
  serverUrl: string = ProductsApi.endPoint;
  category: any = null;
	searchSubscription: Subscription;
  paginator: any = {
    id: 'product-table-paginator',
    currentPage: 1,
    itemsPerPage: environment.productPageSize,
    totalItems: 0
  }
  hasStore: boolean= false;
  initialized: boolean = false;
  isFilter: boolean = false;
  listView: string = 'table';
  params: any = {};  
  minAmount: any = '';
  maxAmount: any = '';
  discountApplies: any = '';
  isProductSelected:boolean = false;
  selectedProducts: any[] = [];
  showSaveButton = false;

  showProduct: boolean = true;
  basicInfo: any;
  isFoodics: Boolean = true;
  constructor(
    private productService: ProductService,
    private loaderService: LoaderService,
    private httpClient: HttpClient,
    private modalService: NgbModal,
    private sharedDataService: SharedDataService
  ) { }

  ngOnInit(): void {
    this.locale = (window as any).LOCALE;
    this.searchSubscription = this.search.asObservable().pipe(debounceTime(300)).subscribe(
      (data) => {
        if (this.searchText != data) {
          this.searchText = data;
          if (this.searchText.length == 0 || this.searchText.length >= 3) {
            this.getPage(1, false);
          }
        }
      }
    );

    this.sharedDataService.asObservable().subscribe((data) => {
      if(data && data.userInfo) {
        this.hasStore = data.userInfo.has_store
        this.basicInfo = data.userInfo
        if(this.hasStore) {
          this.categoryList();
          this.getPage(1);
        } else {
          this.initialized = true;
        }

        if(this.basicInfo?.marketplace_model?.foodics_is_active && this.basicInfo?.marketplace_model?.foodics_is_enable){
          this.isFoodics = true;
        }
        else{
          this.isFoodics = false;
        } 
      }
    });

    
  }

  openAddOns(){
    this.showProduct = false;
  }

  
  onChildHasChanges(hasChanges: boolean) {
    this.showSaveButton = hasChanges;
  }

  triggerSave() {
    if (this.productTableComponent) {
      this.productTableComponent.saveAll();
    }
  }

  closeAddOns(){
    this.showProduct = true;
  }
  
  categoryList() {
    this.loaderService.startLoading();
    this.productService.categories().subscribe(
      (res: any) => {
        this.loaderService.stopLoading();
        this.categories = res.categories.filter((item) => item.products_count > 0);
        this.allProductCount = res.all_product_count;
      },
      err => {
        this.loaderService.stopLoading();
      }
    );
  }

  searchProducts(term: string) {
    this.search.next(term);
  }

  toggleSearch() {
    this.isSearch = !this.isSearch;
    if (this.isSearch) {
      this.searchInput.nativeElement.focus();
    } else {
      this.searchInput.nativeElement.value = "";
      this.searchProducts("");
    }
  }

  toggleFilter() {
    this.isFilter = !this.isFilter;
  }

  filterByCategory(category=null) {
    this.category = category ? category.id : null;
    this.getPage(1, true);
  }

  filterByAmount() {
    this.params.min_amount = this.minAmount;    
    this.params.max_amount = this.maxAmount;
    this.getPage(1, false, this.params);
  }

  resetAmountFilters() {
    if(this.minAmount || this.maxAmount) {
      this.minAmount = "";
      this.maxAmount = "";
      this.filterByAmount();
    }

    if (this.discountApplies) {
      this.discountApplies = "";
      this.filterByDiscount();
    }      
  }

  filterByDiscount() {
    this.params.discount_applies = this.discountApplies;
    this.getPage(1, false, this.params);
  }

  isActive(value=null) {
    return this.category === value;
  };

  onSelectProduct(selected: Array<any>) {
    this.isProductSelected = selected.length > 0;
    this.selectedProducts = selected;
  }

  public getPage(page: number, loading: boolean = true, additionalParams: any = null) {
    this.isProductSelected = false;
    // Unselect selected items
    if (loading) {
      this.loaderService.startLoading();
      this.loading = true; // to show loading text in table
    }

    let params: any = {
      page: page,
      limit: this.paginator.itemsPerPage
    }

    if (this.searchText && this.searchText.length >=3) {
      params.q = this.searchText;
    }

    if (this.category) {
      params.category = this.category
    }

    if (additionalParams) {
      Object.assign(params, additionalParams);
    }

    this.getData(params).subscribe(
      (r) => {
        this.initialized = true;

        if (r.meta) {
          this.paginator.totalItems = r.meta.total;
          this.paginator.currentPage = r.meta.current_page;
          this.paginator.from = r.meta.from;
          this.paginator.to = r.meta.to;
          this.products = r.data;

			    setTimeout(() => {
			      $('#tab-links-select[nice-select]').niceSelect('update');
			    }, 10);
        }

        this.loaderService.stopLoading();
        this.loading = false;
      }, (err) => {
        this.initialized = true;

        this.loading = false;
        this.loaderService.stopLoading()
      }
    )
  }

  getData(params): Observable<any> {
    let url = this.serverUrl;

    if (url.indexOf('?') == -1)
      url += ('?' + queryString(params));
    else
      url += ('&' + queryString(params));

    return this.httpClient.get(`${url}`).pipe(
      catchError((err: any) => {
        this.loaderService.stopLoading()
        return throwError(err);
      })
    )
  }

  ngOnDestroy() {
    this.searchSubscription.unsubscribe();
  }

  openAddProductModal() {
    const modalRef = this.modalService.open(AddProductsComponent);
    const parentElement = modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement;

    // Set id on modal dialog
    // parentElement.id = "add-product-service";
    // parentElement.classList.add( "new-product-service");

    modalRef.result.then(result => {
      this.categoryList();
      this.getPage(1);
    }, fallbackResult => {
      // do nothing
    })
  }

  openImportModal() {
    const modalRef = this.modalService.open(ImportProductModalComponent);
    // Set id on modal dialog
    modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentNode.id = "newClient";
    modalRef.result.then(result => {
      this.categoryList();
      this.getPage(1);
    }, fallbackResult => {
      // do nothing
    })
  }

  onEditProduct() {
    this.categoryList();
    this.getPage(1, false);
  }

  onStatusChange(data:any) {
    this.loaderService.startLoading();
    this.productService.action({'do': 'status-update', 'ids': [data.uuid]}).subscribe(product => {
      this.getPage(1, false, this.params);
      this.loaderService.stopLoading();
    }, err => {
      this.loaderService.stopLoading();
    })
  }

  onDeleteProduct(data:any) {
    if(data.uuid) {
      Swal.fire({
        title: i18n.are_you_sure,
        text: i18n.product.you_want_to_delete_product,
        // icon: 'info',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonColor: "#EB1461",
        confirmButtonText: i18n.delete,
        cancelButtonText: i18n.no_cancel_it,
        customClass: { cancelButton: 'custom_swal_cancel' }
      }).then( result => {
        if(result.value){
          this.loaderService.startLoading();
          this.productService.action({'do': PRODUCT_ACTIONS.DELETE, 'ids': [data.uuid]}).subscribe(data => {
            this.loaderService.stopLoading();
            Swal.fire(i18n.deleted, i18n.product.deleted, 'success');
            this.categoryList();
            this.getPage(1);
          }, err => {
            this.loaderService.stopLoading();
            Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
          });
        }
      });
    }

  }

  deleteProducts() {
    if (this.selectedProducts.length) {
      Swal.fire({
        title: i18n.are_you_sure,
        text: i18n.product.you_want_to_delete_product,
        // icon: 'info',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonColor: "#EB1461",
        confirmButtonText: i18n.delete,
        cancelButtonText: i18n.no_cancel_it,
        customClass: { cancelButton: 'custom_swal_cancel' }
      }).then(result => {
        if(result.value){
          this.loaderService.startLoading();
          this.productService.action({'do': PRODUCT_ACTIONS.DELETE, 'ids': this.selectedProducts}).subscribe(data => {
            this.loaderService.stopLoading();
            Swal.fire(i18n.deleted, i18n.product.deleted, 'success');
            this.categoryList();
            this.getPage(1);
          }, err => {
            this.loaderService.stopLoading();
            Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
          });
        }
      });
    }
  }

  toggleFilters() {
    $('.filters_expanded').toggleClass('visible');
  }

  displayView(viewtype: string) {
    this.listView = viewtype;
    this.isProductSelected = false;
  }

  exportXls() {
    (window as any).open(`${environment.baseUrl}/products/download`, '_self', 'location=yes');
  }

}
